const filterType = document.querySelector('.js-news-filter-type');
const filterShowcase = document.querySelector('.js-news-showcases-only');

const NewsOverview = {
    init() {
        if (filterType && filterShowcase) {
            filterType.addEventListener('change', () => this.onChange('filter-type'));
            filterShowcase.addEventListener('change', () => this.onChange('showcases-only-filter'));
        }

        if (window.location.hash === '#filter-type' && filterType) {
            filterType.focus();
        } else if (window.location.hash === '#showcases-only-filter' && filterShowcase) {
            filterShowcase.focus();
        }
    },
    onChange(triggerId) {
        let url = `/news`;
        if (filterType.value !== 'update') {
            url += `?type=${filterType.value}`;

            if (filterShowcase.checked) {
                url += `&showcase=1`;
            }
        } else if (filterShowcase.checked) {
            url += `?showcase=1`;
        }

        url += `#${triggerId}`;
        window.location.replace(url);
    },
};

export default NewsOverview;
